import * as React from "react";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How fast can Rapid Tech Works start on my IT project?",
  answer: "We pride ourselves on being rapid by name and nature. For standard managed services, we can typically begin the onboarding process within 48 hours. For urgent infrastructure needs, please ",
  linkText: "Contact Us",
  linkUrl: "/ContactPage"
}, {
  question: "Do I have to sign a long-term contract for MSP services?",
  answer: "We believe in earning your business every month. While we offer annual agreements for better predictability, we also provide flexible month-to-month options starting at $125. To discuss what fits your business, ",
  linkText: "Contact Us",
  linkUrl: "/ContactPage"
}, {
  question: "What exactly is included in the $125/month minimum?",
  answer: "Our entry-level tier includes proactive monitoring, essential cybersecurity patches, and remote helpdesk support to keep your core systems running smoothly. For a full breakdown of tiers, ",
  linkText: "Contact Us",
  linkUrl: "/ContactPage"
}, {
  question: "Do you handle physical cabling for new office builds?",
  answer: "Absolutely. We specialize in network rack installation, cable pulling, and wireless access point mapping for both new construction and remodels in Rapid City. To get a quote, ",
  linkText: "Contact Us",
  linkUrl: "/ContactPage"
}];
export default function CommonQuestions() {
  return <section data-section-id="226876" id="common-questions" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-[800px]">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-secondary mb-4">
            Common Questions
          </h2>
          <p className="font-default font-normal text-muted-foreground text-lg">Everything you need to know about partnering with Rapid City's local IT experts.</p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/60 py-2">
              <AccordionTrigger className="font-default font-semibold text-base md:text-lg text-foreground hover:text-primary hover:no-underline transition-all duration-300 text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-default font-normal text-muted-foreground text-base md:text-lg leading-relaxed pt-2 pb-6">
                {faq.answer}
                <Link to={faq.linkUrl} className="text-primary hover:text-secondary transition-colors underline decoration-primary/30 underline-offset-4 font-medium">
                  {faq.linkText}
                </Link>
                .
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}